export default __webpack_public_path__ + "static/media/174hz-Deeper-Sleep.80938454.mp3";